import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-admin-page-title',
  imports: [TranslateModule],
  template: `
    <header>
      <h1>{{ 'admin.title' | translate }}</h1>
    </header>
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminPageTitleComponent {}
